<template>
  <div class="basket-items-list">
    <div
      v-for="item in groupedItems"
      :key="item.key"
      class="basket-items-list_row"
    >
      <div class="basket-items-list_name">
        <span class="basket-items-list_title">
          {{ item.name }}
          <span class="basket-items-list_count">&times;&nbsp;{{ item.count }}</span>
        </span>
        <span v-if="item.modification" class="basket-items-list_modification">
          {{ item.modification }}
        </span>
      </div>
      <span class="basket-items-list_price">{{ item.price | amountWithCurrency }}</span>
    </div>
    <div v-if="!groupedItems.length" class="basket-items-list_empty">
      Состав недоступен
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BasketItemsList',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      // Бэкенд отдаёт по строке на единицу товара: одинаковые позиции сворачиваем
      // в одну строку с количеством. Сервисный сбор в состав не показываем.
      groupedItems () {
        const groups = []
        const index = {}

        this.items.forEach((item) => {
          if (item.serviceFee) {
            return
          }

          const key = [
            item.menuItemId,
            item.modificationMenuItemId || 0,
            item.price,
          ].join(':')

          if (index[key]) {
            index[key].count += 1
            return
          }

          index[key] = {
            key,
            name: item.menuItem?.name || 'Без названия',
            modification: item.modificationMenuItem?.name || null,
            // price, а не sellPrice: в списочном ресурсе заказов sellPrice не отдаётся,
            // а в полном он заполнен только когда списывались бонусы
            price: item.price,
            count: 1,
          }
          groups.push(index[key])
        })

        return groups
      },
    },
  }
</script>

<style lang="less" scoped>
.basket-items-list {
  width: 100%;
  align-self: stretch;
  flex: 0 0 auto;
  max-height: 45vh;
  overflow-y: auto;
  color: #ffffff;

  &_row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);

    &:last-child {
      border-bottom: none;
    }
  }

  &_name {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &_title {
    font-size: 15px;
    line-height: 1.25;
  }

  // Количество идёт сразу за названием, а не отдельной колонкой у цены
  &_count {
    font-size: 15px;
    margin-left: 6px;
    color: rgba(255, 255, 255, 0.7);
    white-space: nowrap;
  }

  &_modification {
    font-size: 13px;
    line-height: 1.25;
    margin-top: 2px;
    color: rgba(255, 255, 255, 0.7);
  }

  &_price {
    font-size: 15px;
    font-weight: 500;
    flex-shrink: 0;
    white-space: nowrap;
  }

  &_empty {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.7);
    padding: 8px 0;
  }
}
</style>
